(function () {
    'use strict';

    function initialize() {

        class UserContext {
            constructor(userContext) {
                angular.extend(this, userContext);
            }

            showCalendarHoursLeft() {
                return this.calendarHoursVisibility === 'Left' || this.calendarHoursVisibility === 'LeftAndRight';
            }

            showCalendarHoursRight() {
                return this.calendarHoursVisibility === 'Right' || this.calendarHoursVisibility === 'LeftAndRight';
            }

            showCalendarHoursBetweenCalendars() {
                return this.calendarHoursVisibility === 'BetweenCalendars';
            }

            isTeleSecretariaat() {
                return this.rolnaam === 'Telesecretariaat';
            }

            isSecretariaat() {
                return this.rolnaam === 'Secretariaat';
            }

            isDokter() {
                return this.rolnaam === 'Agendabeheerder';
            }

            isAdmin() {
                return this.admin;
            }

            isDoorverwijzer() {
                return false;
            }

            magAgendaExporteren() {
                return true;
            }

            isAdminApp() {
                return true;
            }
        }

        let cannonicalName = document.URL.split('/')[3];


        const injector = angular.injector(['ng', 'doclr.keycloak', 'doclr.appconfig']);
        const $http = injector.get('$http');
        const app = angular.module('doclr.admin.app');
        const KeycloakService = injector.get('KeycloakService');
        const AppConfigService = injector.get('AppConfigService');

        let tenantSlug = window.location.href.replaceAll(window.origin, "").split("/")[1];
        return fetch(AppConfigService.getApiUrl() + "/public/api/auth/v1/" + tenantSlug + "/keycloak-config")
            .then(x => x.json())
            .then(keycloakConfig => KeycloakService.initKeycloak(keycloakConfig.realm, keycloakConfig.url, keycloakConfig.clientId))
            .then(() => {
                return $http.get(AppConfigService.getApiUrl() + '/apiv0/' + cannonicalName + '/admin/initial-data', {
                    headers: {'Authorization': 'Bearer ' + KeycloakService.getToken()}
                });
            })
            .then((response) => {
                response.data.praktijkContext.vgDisabledFeature = true;

                let appContext = response.data.appContext;

                if (appContext) {
                    KeycloakService.setAppContext(appContext);
                    if (appContext.resources) {
                        appContext.resources = appContext.resources.sort((a, b) => a.name.localeCompare(b.name));
                    }
                }

                const navUrlParams = new URLSearchParams(window.location.search);
                const navAppointmentId = navUrlParams.get('navappointment') || null;
                if (navAppointmentId) {
                    navUrlParams.delete('navappointment');
                    const cleanSearch = navUrlParams.toString();
                    history.replaceState(null, '', window.location.pathname + (cleanSearch ? '?' + cleanSearch : '') + window.location.hash);
                }

                app.constant('agendaUrlRoot', AppConfigService.getApiUrl() + '/apiv0');
                app.constant('navAppointmentId', navAppointmentId);
                app.constant('userContext', new UserContext(response.data.userContext));
                app.constant('omgeving', response.data.omgeving);
                app.constant('praktijkAfgewerkt', response.data.omgeving === 'triage');
                app.constant('omgevingUri', response.data.omgevingUri);
                app.constant('burgerUri', response.data.burgerUri);
                app.constant('adminUri', response.data.adminUri);
                app.constant('appContext', response.data.appContext);
                app.constant('calendars', response.data.calendars);
                app.constant('beschikbaarheidTypesCache', response.data.beschikbaarheidTypes);
                app.constant('customForms', customFormConfigFactory.create(response.data.beschikbaarheidTypes));
                app.constant('praktijkContext', response.data.praktijkContext);
                app.constant('supportedLanguages', ['nl', 'fr', 'en', 'de', 'uk']);

                applyBranding(response.data.appContext.brandingSettings);
                applyMonkeyFixPopoverHorizontalScroll();
            })
            .catch(() => window.location = 'https://agendas.docleas.eu/' + cannonicalName + '/no-access');
    }

    function applyBranding(brandingSettings) {
        document.documentElement.style.setProperty('--doclr-color-primary', brandingSettings.colors.primary);
        document.documentElement.style.setProperty('--mat-option-selected-state-layer-color', brandingSettings.colors.primary);
        document.documentElement.style.setProperty('--mat-sys-primary', brandingSettings.colors.primary);
        document.documentElement.style.setProperty('--doclr-color-primary-dark', brandingSettings.colors.primaryDark);

        if (brandingSettings.flexibleCalendarWidth && brandingSettings.flexibleCalendarWidth.hasFlexibleCalendarWidth) {
            document.documentElement.style.setProperty('--doclr-calendar-column-width', '' + brandingSettings.flexibleCalendarWidth.flexibleCalendarWidth + 'px');
        }

        if (brandingSettings.colors.link) {
            document.documentElement.style.setProperty('--doclr-color-link', brandingSettings.colors.link);
            document.documentElement.style.setProperty('--doclr-color-link-dark', shade(brandingSettings.colors.link, -10));

        }

        function shade(color, amount) {
            return '#' + color.replace(/^#/, '').replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
        }
    }

    function applyMonkeyFixPopoverHorizontalScroll() {

        if (!$.fn.popover || !$.fn.popover.Constructor) return;

        var Popover = $.fn.popover.Constructor;
        if (Popover.prototype.applyPlacement.__patched) return;


        Popover.prototype.applyPlacement = function (offset, placement) {
            var $tip = this.tip()
            var width = $tip[0].offsetWidth
            var height = $tip[0].offsetHeight

            // manually read margins because getBoundingClientRect includes difference
            var marginTop = parseInt($tip.css('margin-top'), 10)
            var marginLeft = parseInt($tip.css('margin-left'), 10)

            // we must check for NaN for ie 8/9
            if (isNaN(marginTop)) marginTop = 0
            if (isNaN(marginLeft)) marginLeft = 0

            offset.top += marginTop
            offset.left += marginLeft

            // $.fn.offset doesn't round pixel values
            // so we use setOffset directly with our own function B-0
            $.offset.setOffset($tip[0], $.extend({
                using: function (props) {
                    $tip.css({
                        top: Math.round(props.top),
                        left: Math.round(props.left)
                    })
                }
            }, offset), 0)

            $tip.addClass('in')

            // check to see if placing tip in new offset caused the tip to resize itself
            var actualWidth = $tip[0].offsetWidth
            var actualHeight = $tip[0].offsetHeight

            if (placement == 'top' && actualHeight != height) {
                offset.top = offset.top + height - actualHeight
            }

            var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

            if (delta.left) offset.left += delta.left
            else offset.top += delta.top

            var isVertical = /top|bottom/.test(placement)
            var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
            var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

            // if ($(document, window).scrollLeft() === 0) {
            //     $tip.offset(offset)
            //     this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
            // }
        }

    }

    function bootstrap() {
        angular.element(document).ready(function () {
            angular.bootstrap(document, ['doclr.admin.app']);
        });
    }

    initialize().then(bootstrap);
})();